var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.ad.url),expression:"ad.url"}],staticClass:"fa fa-link",style:({opacity: _vm.ad.url ? 1 : 0.2})})
}
var staticRenderFns = []

export { render, staticRenderFns }